const AddSquareIcon = ({ ...props }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="8.80005" cy="8" r="8" fill="currentColor" />
      <path
        d="M11.4668 6.66675L8.80013 9.33341L6.13346 6.66675"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AddSquareIcon;
